import { Button, Dialog, DialogActions, DialogContent, DialogTitle, type ButtonProps } from '@mui/material'

type Props = {
  cancelLabel?: string
  confirmLabel?: string
  children: React.ReactNode
  disableClickAway?: boolean
  loading?: boolean
  open: boolean
  title?: string
  onClose: () => void
  onConfirm: () => void
  cancelButtonProps?: ButtonProps
  confirmButtonProps?: ButtonProps
}

export const ConfirmDialog = ({
  cancelLabel = 'Cancel',
  confirmLabel = 'Submit',
  children,
  loading,
  open,
  title,
  onClose,
  onConfirm,
  cancelButtonProps,
  confirmButtonProps,
  disableClickAway = false,
}: Props) => {
  return (
    <Dialog
      open={open}
      onClose={disableClickAway ? undefined : onClose}
      aria-describedby="dialogcontent"
      aria-labelledby="dialogtitle"
    >
      {title && (
        <DialogTitle variant="h2" component="h2" color="primary" id="dialogtitle">
          {title}
        </DialogTitle>
      )}
      <DialogContent id="dialogcontent">{children}</DialogContent>

      <DialogActions>
        <Button variant="outlined" color="secondary" {...cancelButtonProps} onClick={onClose} disabled={!!loading}>
          {cancelLabel}
        </Button>
        <Button variant="contained" color="secondary" {...confirmButtonProps} onClick={onConfirm} loading={!!loading}>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
